import { GOOD_TO_KNOW } from '@ria-client/advisor-search/constants';
import { Section } from '@ria-client/tw-shared-ui/layout/section';

import { CardCtaLink } from './CardCtaLink';
import { LinkCard } from './LinkCard';
import { LinkCardGrid } from './LinkCardGrid';
import { SectionHeader } from './SectionHeader';
import { InfoIcon } from './icons';

export function GoodToKnowSection() {
  return (
    <Section aria-label="Good to know about financial advisors">
      <SectionHeader
        icon={<InfoIcon className="size-4.5" />}
        title="Good to know"
        subtitle="Before you hire a financial advisor, understand what questions to ask, what to expect in your initial meetings and how much you might pay. Below are some articles that will take you through the basics. "
      />
      <LinkCardGrid>
        {GOOD_TO_KNOW.map(article => (
          <LinkCard key={article.title} href={article.url}>
            <span className="mb-2 flex items-center justify-between">
              <span className="advisor-search-article-emoji">{article.icon}</span>
              <span className="typography-text-extra-small rounded-sm bg-muted px-2 py-0.5 font-medium text-muted-foreground">
                {article.readTime}
              </span>
            </span>
            <h4 className="typography-card-title mb-1">{article.title}</h4>
            <span className="typography-text-small mb-2 flex-1 text-muted-foreground">
              {article.synopsis}
            </span>
            <CardCtaLink label="Read on NerdWallet" bold />
          </LinkCard>
        ))}
      </LinkCardGrid>
    </Section>
  );
}
